<div [formGroup]="form" [ngClass]="type">
  <ng-container *ngIf="question">
    <!-- RADIO BUTTONS -->
    <div [formGroupName]="type" *ngIf="!question.isMultipleChoice">
      <mat-radio-group class="form-item row"
                       [class.has-images]="question.answers[0].imagePath"
                       [class.has-question-image]="question.imagePath"
                       [formControlName]="createFormControlName(parentQuestion, question)">
        <div class="question-label-container col-xs-12" [ngClass]="displayFieldCss(type+'.'+(createFormControlName(parentQuestion, question)))">
          <mat-label class="question-label h3">
            {{ question.label }}
            <span [ngClass]="required ? 'required' : 'hide'">*</span>
          </mat-label>
          <span class="error-message" [innerHTML]="'$common_select_one' | translate"></span>
        </div>
        <ng-container *ngFor="let answer of question.answers">
          <mat-radio-button class="form-field col-xs-6"
                            [value]="answer"
                            (change)="radioChange($event, question)">
            <img *ngIf="answer.imagePath" [src]="(imagePath + answer.imagePath).toLowerCase()" />
            <button mat-icon-button
                    matTooltipPosition="above"
                    matTooltip="{{'$evaluation_posture_not _typical' | translate}}"
                    matTooltipClass="question-warning-tooltip-content"
                    aria-label="Button that shows a red tooltip"
                    class="question-warning-tooltip ideal-message"
                    [ngClass]="answer.isIdeal ? 'ideal' : 'not-ideal'"
                    *ngIf="!parentQuestion">
              <mat-icon>warning</mat-icon>
            </button>
            <span [class.no-image]="!answer.imagePath">{{answer.label}}</span>
          </mat-radio-button>
          <!-- <mat-form-field *ngIf="answer.inputType === 'text'" class="col-xs-12 form-field">
            <mat-label [innerHTML]="'$common_optional_description' | translate"></mat-label>
            <input matInput type="text"
                    [value]="answer.text || ''"
                    (input)="onKeyPress($event.target.value, null, createFormControlName(parentQuestion, question), answer)"
                    [disabled]="readOnly" />
          </mat-form-field> -->
        </ng-container>
        <!-- dynamically create as many radio-button inputs as needed. Add col-xs-# for column styling. See flexboxgrid.scss -->
        <div *ngIf="question.imagePath" class="help-image-container">
          <figure class="help-image link">
            <img [src]="(imagePath + question.imagePath).toLowerCase()" />
          </figure>
        </div>
      </mat-radio-group>

      <div *ngIf="followUp" class="follow-up-form-item">
        <ol>
          <li *ngFor="let childQuestion of question.childQuestions; let x = index;">
            <cz-radio-checkbox-group [type]="type"
                                      [question]="childQuestion"
                                      [parentQuestion]="question"
                                      [form]="form"
                                      [imagePath]="childQuestion.imagePath">
            </cz-radio-checkbox-group>
          </li>
        </ol>
      </div>
    </div>

    <!-- CHECKBOXES -->
    <div [formGroupName]="type" *ngIf="question.isMultipleChoice">
      <div class="form-item alternate-theme row"
           [class.has-images]="question.answers[0].imagePath || question.imagePath"
           [formGroupName]="createFormControlName(parentQuestion, question)">
        <div class="question-label-container col-xs-12" [ngClass]="displayFieldCss(type+'.'+(createFormControlName(parentQuestion, question)))">
          <mat-label class="question-label h3"><!-- survey_multiple_answers -->
            {{ question.label }} {{'$survey_multiple_answers' | translate}}
            <span [ngClass]="required ? 'required' : 'hide'">*</span>
          </mat-label>
          <span class="error-message" [innerHTML]="'$common_select_multiple' | translate"></span>
        </div>
        <div *ngIf="question.imagePath" class="col-xs-2 end-xs help-image-container">
          <figure class="help-image link">
            <img [src]="(imagePath + question.imagePath).toLowerCase()" />
          </figure>
        </div>
        <ng-container *ngFor="let answer of question.answers">
          <mat-checkbox class="form-field col-xs-6"
                        [formControlName]="answer.id">
            <img *ngIf="answer.imagePath" [src]="(imagePath + answer.imagePath).toLowerCase()" />
            <span [class.no-image]="!answer.imagePath">{{answer.label}}</span>
          </mat-checkbox>
          <!-- <mat-form-field *ngIf="answer.inputType === 'text'" class="col-xs-12 form-field">
            <mat-label [innerHTML]="'$common_optional_description' | translate"></mat-label>
            <input matInput type="text"
                    [value]="answer.text || ''"
                    (input)="onKeyPress($event.target.value, createFormControlName(parentQuestion, question), answer.id, answer)"
                    [disabled]="readOnly" />
            </mat-form-field> -->
          </ng-container>
        <!-- dynamically create as many checkbox inputs as needed. Add col-xs-# for column styling. See flexboxgrid.scss -->
      </div>
    </div>
  </ng-container>
</div>
